import React from "react";
import {isMobile} from 'react-device-detect';
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import PurchaseCancelledPage from "../components/Sections/PurchaseCancelledPage";
import Footer from "../components/Sections/Footer";

export default function PurchaseCancelled() {
  return (
    <div style={{position: "relative", minHeight: '100vh'}}>
      <div style={{paddingBottom: isMobile ? "3.3rem" : '1rem'}}>
        <TopNavbar/>
        <PurchaseCancelledPage />
      </div>
      <Footer />
    </div>
  );
}


